import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f7264200")

_pushScopeId("data-v-f7264200")
const _hoisted_1 = { class: "reel-voice-picker mb-3" }
const _hoisted_2 = {
  class: "reel-voice-picker__filters mb-2",
  role: "group",
  "aria-label": "Filter by provider"
}
const _hoisted_3 = {
  key: 0,
  class: "reel-voice-picker__list",
  role: "listbox",
  "aria-label": "Voice options"
}
const _hoisted_4 = {
  class: "reel-voice-picker__radio",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  key: 0,
  class: "reel-voice-picker__radio-dot"
}
const _hoisted_6 = { class: "reel-voice-picker__label" }
const _hoisted_7 = { class: "reel-voice-picker__meta" }
const _hoisted_8 = { class: "reel-voice-picker__pill" }
const _hoisted_9 = {
  key: 0,
  class: "reel-voice-picker__credits text-muted"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-play" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "text-muted fs-8 mb-0 px-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event)),
      type: "search",
      class: "form-control form-control-sm reel-voice-picker__search mb-2",
      placeholder: "Search voices…",
      "aria-label": "Search voices",
      disabled: _ctx.disabled
    }, null, 8, ["disabled"]), [
      [_vModelText, _ctx.searchQuery]
    ]),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.providerChips, (chip) => {
        return (_openBlock(), _createBlock("button", {
          key: chip.id,
          type: "button",
          class: ["reel-voice-picker__chip", { 'reel-voice-picker__chip--active': _ctx.providerFilter === chip.id }],
          disabled: _ctx.disabled,
          onClick: ($event: any) => (_ctx.providerFilter = chip.id)
        }, _toDisplayString(chip.label), 11, ["disabled", "onClick"]))
      }), 128))
    ]),
    (_ctx.filteredVoices.length)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredVoices, (voice) => {
            return (_openBlock(), _createBlock("div", {
              key: voice.id,
              class: ["reel-voice-picker__row", { 'reel-voice-picker__row--selected': voice.id === _ctx.modelValue }],
              role: "option",
              "aria-selected": voice.id === _ctx.modelValue,
              tabindex: _ctx.disabled ? -1 : 0,
              onClick: ($event: any) => (_ctx.selectVoice(voice)),
              onKeydown: [
                _withKeys(_withModifiers(($event: any) => (_ctx.selectVoice(voice)), ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(($event: any) => (_ctx.selectVoice(voice)), ["prevent"]), ["space"])
              ]
            }, [
              _createVNode("span", _hoisted_4, [
                (voice.id === _ctx.modelValue)
                  ? (_openBlock(), _createBlock("span", _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("span", _hoisted_6, _toDisplayString(voice.label), 1),
              _createVNode("span", _hoisted_7, [
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.providerLabel(voice.provider)), 1),
                (voice.estimatedCredits)
                  ? (_openBlock(), _createBlock("span", _hoisted_9, " ~" + _toDisplayString(voice.estimatedCredits), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("button", {
                type: "button",
                class: "reel-voice-picker__play btn btn-link btn-sm p-0",
                disabled: _ctx.disabled || !voice.previewUrl,
                "aria-label": `Preview ${voice.label}`,
                onClick: _withModifiers(($event: any) => (_ctx.$emit('preview', voice)), ["stop","prevent"])
              }, [
                _hoisted_10
              ], 8, ["disabled", "aria-label", "onClick"])
            ], 42, ["aria-selected", "tabindex", "onClick", "onKeydown"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("p", _hoisted_11, " No voices match your search. "))
  ], 512)), [
    [_vShow, _ctx.expanded]
  ])
})